var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAIcreate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 258,
    height: 216,
    viewBox: "0 0 258 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_6035",
    x: 0,
    y: 66,
    width: 202,
    height: 48,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_6036",
    x: 0.023,
    y: 65.858,
    width: 201.217,
    height: 48.768,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_525",
    x: 65,
    y: 43,
    width: 32,
    height: 32,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_526",
    x: 25,
    y: 24,
    width: 37,
    height: 38,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-4"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_527",
    x: 59,
    y: 125,
    width: 30,
    height: 30,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-5"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.065,
    cy: 0.978,
    r: 1.27,
    gradientTransform: "translate(0)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#fa8f21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#d82d7e"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 0.693,
    cy: 0.946,
    r: 1.117,
    gradientTransform: "translate(0)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#8c3aaa",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8c3aaa"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_529",
    x: 104.001,
    y: 0,
    width: 43,
    height: 42,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-6"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-6"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_528",
    x: 158.001,
    y: 40,
    width: 38,
    height: 37,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-7"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-7"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_6091",
    x: 117,
    y: 112,
    width: 141,
    height: 104,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-8"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-8"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "AI_Image_3",
    "data-name": "AI Image 3",
    transform: "translate(-987 -707)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_420",
    "data-name": "Ellipse 420",
    cx: 67.5,
    cy: 69.5,
    rx: 67.5,
    ry: 69.5,
    transform: "translate(1045 750)",
    fill: "#fff6f0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_65892",
    "data-name": "Group 65892",
    transform: "translate(996.001 779.192)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -72.19)",
    filter: "url(#Rectangle_6035)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6035-2",
    "data-name": "Rectangle 6035",
    width: 184,
    height: 30,
    rx: 15,
    transform: "translate(9 72)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -72.19)",
    filter: "url(#Rectangle_6036)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6036-2",
    "data-name": "Rectangle 6036",
    width: 182.217,
    height: 29.768,
    rx: 14.884,
    transform: "translate(9.52 72.36)",
    fill: "none",
    stroke: "rgba(255,255,255,0.3)",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_34880",
    "data-name": "Path 34880",
    d: "M212.549,189.817a.756.756,0,0,0-.943-.782s.283-.08-.034.01a7.217,7.217,0,1,0,3.856,0c-.313-.087-.019-.005-.019-.005a.759.759,0,0,0-.943.782v6.125c0,.135.076.168.17.071,0,0,.778-.792,1.056-1.08a.968.968,0,1,1,1.365,1.372l-2.937,2.969a.844.844,0,0,1-1.2,0l-2.968-2.972a.968.968,0,0,1,1.356-1.382c.287.3,1.065,1.089,1.065,1.089.094.1.171.065.171-.07Z",
    transform: "translate(-195.395 -181.167)",
    fill: "#7be832",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34881",
    "data-name": "Path 34881",
    d: "M231.137,197.74l1.8-.373a2.114,2.114,0,0,0,.812,1.413,2.862,2.862,0,0,0,1.77.5,2.747,2.747,0,0,0,1.64-.455,1.415,1.415,0,0,0,.649-1.185,1.25,1.25,0,0,0-.276-.812,1.8,1.8,0,0,0-.731-.552,9.052,9.052,0,0,0-1.023-.373,10.336,10.336,0,0,0-1.169-.325,6.97,6.97,0,0,1-1.185-.406,6.164,6.164,0,0,1-1.023-.585,2.376,2.376,0,0,1-.714-.893,2.976,2.976,0,0,1-.276-1.315,2.814,2.814,0,0,1,1.137-2.289,4.906,4.906,0,0,1,5.667-.049,3.375,3.375,0,0,1,1.331,2.241l-1.819.373a2.263,2.263,0,0,0-.779-1.4,2.4,2.4,0,0,0-1.607-.536,2.361,2.361,0,0,0-1.494.455,1.33,1.33,0,0,0-.585,1.1,1.214,1.214,0,0,0,.471.974,2.953,2.953,0,0,0,1.185.568q.714.162,1.543.438a13.478,13.478,0,0,1,1.543.585,2.684,2.684,0,0,1,1.185,1.023,3.008,3.008,0,0,1,.471,1.721,2.836,2.836,0,0,1-1.2,2.338,4.751,4.751,0,0,1-2.988.925,4.92,4.92,0,0,1-2.955-.844A3.291,3.291,0,0,1,231.137,197.74Zm13.658-5.5a3.694,3.694,0,0,1,2.436.779,2.743,2.743,0,0,1,.942,2.241V200.7h-1.7v-2.208a3.018,3.018,0,0,1-3.069,2.371,2.594,2.594,0,0,1-1.786-.633,2.176,2.176,0,0,1-.714-1.689,2.069,2.069,0,0,1,.861-1.819,4.551,4.551,0,0,1,2.192-.763l1.607-.162q.909-.081.909-.812a1.141,1.141,0,0,0-.471-.958,1.89,1.89,0,0,0-1.2-.357,2.149,2.149,0,0,0-1.3.39,1.785,1.785,0,0,0-.666,1.137l-1.689-.406a2.825,2.825,0,0,1,1.218-1.851A4.121,4.121,0,0,1,244.8,192.236Zm-.844,7.242a2.488,2.488,0,0,0,1.786-.7,2.249,2.249,0,0,0,.731-1.656v-.455q-.195.325-.942.406l-1.575.195a2,2,0,0,0-.99.373.911.911,0,0,0-.357.763.956.956,0,0,0,.357.779A1.563,1.563,0,0,0,243.951,199.478Zm9.264.7,2.549-7.778H257.5l-2.906,8.3H251.7l-2.906-8.3h1.851Zm8.735-7.94a4.113,4.113,0,0,1,3.247,1.429,4.294,4.294,0,0,1,1.023,3.459h-6.868a2.7,2.7,0,0,0,.926,1.64,2.738,2.738,0,0,0,1.8.617,2.7,2.7,0,0,0,1.445-.39,2.783,2.783,0,0,0,1.007-1.088l1.429.633a4.3,4.3,0,0,1-1.575,1.689,4.38,4.38,0,0,1-2.354.633,4.315,4.315,0,0,1-3.134-1.234,4.111,4.111,0,0,1-1.267-3.069,4.243,4.243,0,0,1,4.319-4.319Zm0,1.478a2.476,2.476,0,0,0-1.64.585,2.734,2.734,0,0,0-.909,1.494h5.1a2.616,2.616,0,0,0-.909-1.494A2.436,2.436,0,0,0,261.95,193.714Zm15.785-1.478a3.384,3.384,0,0,1,2.679,1.25,4.93,4.93,0,0,1,0,6.138,3.4,3.4,0,0,1-2.679,1.234,3.237,3.237,0,0,1-2.046-.682,3.941,3.941,0,0,1-1.25-1.884v5.651h-1.7V192.4h1.7v2.4a3.841,3.841,0,0,1,1.25-1.867A3.188,3.188,0,0,1,277.735,192.236Zm-.568,7.047a2.373,2.373,0,0,0,1.8-.779,2.741,2.741,0,0,0,.747-1.948,2.7,2.7,0,0,0-.747-1.948,2.35,2.35,0,0,0-1.8-.8,2.664,2.664,0,0,0-1.965.779,2.89,2.89,0,0,0,0,3.913A2.663,2.663,0,0,0,277.167,199.283Zm9.821-7.047a4.113,4.113,0,0,1,3.247,1.429,4.294,4.294,0,0,1,1.023,3.459h-6.868a2.7,2.7,0,0,0,.926,1.64,2.738,2.738,0,0,0,1.8.617,2.7,2.7,0,0,0,1.445-.39,2.783,2.783,0,0,0,1.007-1.088l1.429.633a4.3,4.3,0,0,1-1.575,1.689,4.38,4.38,0,0,1-2.354.633,4.315,4.315,0,0,1-3.134-1.234,4.111,4.111,0,0,1-1.266-3.069,4.243,4.243,0,0,1,4.319-4.319Zm0,1.478a2.475,2.475,0,0,0-1.64.585,2.734,2.734,0,0,0-.909,1.494h5.1a2.616,2.616,0,0,0-.909-1.494A2.436,2.436,0,0,0,286.987,193.714Zm7.621-1.315v2.192a3.188,3.188,0,0,1,1.267-2,2.585,2.585,0,0,1,1.981-.26v1.624a2.739,2.739,0,0,0-2.306.244,2,2,0,0,0-.942,1.8V200.7h-1.7v-8.3Zm14.366-.162a2.585,2.585,0,0,1,2.095.99,3.79,3.79,0,0,1,.828,2.517V200.7h-1.7V196a2.315,2.315,0,0,0-.536-1.575,1.614,1.614,0,0,0-1.3-.633,1.856,1.856,0,0,0-1.445.633A2.273,2.273,0,0,0,306.36,196V200.7h-1.7V196a2.361,2.361,0,0,0-.52-1.575,1.614,1.614,0,0,0-1.3-.633,1.856,1.856,0,0,0-1.445.633,2.273,2.273,0,0,0-.552,1.575V200.7h-1.7v-8.3h1.7v2.03a3.527,3.527,0,0,1,1.023-1.607,2.453,2.453,0,0,1,1.624-.585,2.484,2.484,0,0,1,1.7.633,3.259,3.259,0,0,1,1.023,1.672,3.259,3.259,0,0,1,1.023-1.672A2.605,2.605,0,0,1,308.974,192.236Zm8.174,0a3.694,3.694,0,0,1,2.436.779,2.743,2.743,0,0,1,.942,2.241V200.7h-1.7v-2.208a3.018,3.018,0,0,1-3.069,2.371,2.594,2.594,0,0,1-1.786-.633,2.176,2.176,0,0,1-.714-1.689,2.069,2.069,0,0,1,.861-1.819,4.551,4.551,0,0,1,2.192-.763l1.607-.162q.909-.081.909-.812a1.141,1.141,0,0,0-.471-.958,1.89,1.89,0,0,0-1.2-.357,2.149,2.149,0,0,0-1.3.39,1.785,1.785,0,0,0-.666,1.137l-1.689-.406a2.825,2.825,0,0,1,1.218-1.851A4.121,4.121,0,0,1,317.149,192.236Zm-.844,7.242a2.488,2.488,0,0,0,1.786-.7,2.249,2.249,0,0,0,.731-1.656v-.455q-.195.325-.942.406l-1.575.195a2,2,0,0,0-.99.373.911.911,0,0,0-.357.763.956.956,0,0,0,.357.779A1.563,1.563,0,0,0,316.3,199.478Zm10.736-7.242a2.962,2.962,0,0,1,2.306.99,3.616,3.616,0,0,1,.893,2.517V200.7h-1.7V196a2.133,2.133,0,0,0-.617-1.575,2.046,2.046,0,0,0-1.526-.633,2.3,2.3,0,0,0-1.672.633,2.077,2.077,0,0,0-.649,1.575V200.7h-1.7v-8.3h1.7v2.143a3.4,3.4,0,0,1,1.12-1.689A2.935,2.935,0,0,1,327.041,192.236Zm9.038,0a4.113,4.113,0,0,1,3.247,1.429,4.294,4.294,0,0,1,1.023,3.459h-6.868a2.7,2.7,0,0,0,.926,1.64,2.738,2.738,0,0,0,1.8.617,2.7,2.7,0,0,0,1.445-.39,2.783,2.783,0,0,0,1.007-1.088l1.429.633a4.3,4.3,0,0,1-1.575,1.689,4.38,4.38,0,0,1-2.354.633,4.315,4.315,0,0,1-3.134-1.234,4.111,4.111,0,0,1-1.267-3.069,4.243,4.243,0,0,1,4.319-4.319Zm0,1.478a2.475,2.475,0,0,0-1.64.585,2.734,2.734,0,0,0-.909,1.494h5.1a2.615,2.615,0,0,0-.909-1.494A2.436,2.436,0,0,0,336.079,193.714Zm10.593-1.478a2.962,2.962,0,0,1,2.306.99,3.616,3.616,0,0,1,.893,2.517V200.7h-1.7V196a2.133,2.133,0,0,0-.617-1.575,2.046,2.046,0,0,0-1.526-.633,2.3,2.3,0,0,0-1.672.633A2.077,2.077,0,0,0,343.7,196V200.7H342v-8.3h1.7v2.143a3.4,3.4,0,0,1,1.12-1.689A2.935,2.935,0,0,1,346.672,192.236Zm5.752,1.672h-1.77V192.4h1.77v-2.7l1.7-.536V192.4h2.338v1.51h-2.338v3.832a1.515,1.515,0,0,0,.341,1.1,1.489,1.489,0,0,0,1.088.341h.909v1.51h-.909a3.277,3.277,0,0,1-2.371-.747,3.076,3.076,0,0,1-.763-2.289Zm7.339,6.787h-1.7V188.68h1.7Zm5.272-.471,2.63-7.826H369.4l-3.9,11.545h-1.737l1.1-3.247h-1.348l-2.825-8.3h1.851Z",
    transform: "translate(-197.828 -181.136)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_65898",
    "data-name": "Group 65898",
    transform: "translate(1061.324 759.313)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -74.32, -52.31)",
    filter: "url(#Ellipse_525)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_525-2",
    "data-name": "Ellipse 525",
    cx: 7,
    cy: 7,
    r: 7,
    transform: "translate(74 52)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "facebook-svgrepo-com_5_",
    "data-name": "facebook-svgrepo-com (5)",
    transform: "translate(1.56 1.637)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34577",
    "data-name": "Path 34577",
    d: "M10.8,5.908a4.9,4.9,0,1,0-5.665,4.848V7.326H3.888V5.908H5.132V4.827a1.731,1.731,0,0,1,1.85-1.91,7.5,7.5,0,0,1,1.1.1V4.221H7.461a.708.708,0,0,0-.8.766v.921H8.022L7.8,7.326H6.663v3.43A4.906,4.906,0,0,0,10.8,5.908Z",
    transform: "translate(-0.993 -1)",
    fill: "#1877f2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_65897",
    "data-name": "Group 65897",
    transform: "translate(1020.615 740.377)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -33.61, -33.38)",
    filter: "url(#Ellipse_526)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_526-2",
    "data-name": "Ellipse 526",
    cx: 9.5,
    cy: 10,
    rx: 9.5,
    ry: 10,
    transform: "translate(34 33)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "twitter-x-seeklogo.com-4",
    transform: "translate(2.678 2.607)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_398",
    "data-name": "Ellipse 398",
    cx: 7.057,
    cy: 7.057,
    r: 7.057,
    transform: "translate(0 0)",
    fill: "#32a3ea",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(2.689 2.968)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1009",
    d: "M483.961,356.79l3.373,4.51-3.394,3.667h.764l2.972-3.211,2.4,3.211h2.6l-3.563-4.764,3.16-3.413h-.764l-2.737,2.957-2.211-2.957Zm1.124.563h1.194l5.274,7.052h-1.194Z",
    transform: "translate(-483.94 -356.79)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_65896",
    "data-name": "Group 65896",
    transform: "translate(1054.697 840.729)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -67.7, -133.73)",
    filter: "url(#Ellipse_527)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_527-2",
    "data-name": "Ellipse 527",
    cx: 6,
    cy: 6,
    r: 6,
    transform: "translate(68 134)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "instagram-2-1-logo-svgrepo-com_1_",
    "data-name": "instagram-2-1-logo-svgrepo-com (1)",
    transform: "translate(3.025 3.436)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34579",
    "data-name": "Path 34579",
    d: "M1.673,6.573a2.221,2.221,0,0,1-.747-.138,1.25,1.25,0,0,1-.463-.3,1.24,1.24,0,0,1-.3-.462,2.221,2.221,0,0,1-.138-.747C0,4.5,0,4.373,0,3.3S0,2.1.023,1.673A2.233,2.233,0,0,1,.162.926a1.255,1.255,0,0,1,.3-.463,1.242,1.242,0,0,1,.463-.3A2.221,2.221,0,0,1,1.672.023C2.1,0,2.224,0,3.3,0S4.5,0,4.924.023a2.233,2.233,0,0,1,.747.138,1.245,1.245,0,0,1,.463.3,1.246,1.246,0,0,1,.3.463,2.221,2.221,0,0,1,.138.747c.019.424.023.551.023,1.626s0,1.2-.023,1.626a2.231,2.231,0,0,1-.138.747,1.332,1.332,0,0,1-.764.763,2.221,2.221,0,0,1-.747.138C4.5,6.592,4.372,6.6,3.3,6.6s-1.2,0-1.625-.023",
    transform: "translate(0 0)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34580",
    "data-name": "Path 34580",
    d: "M1.673,6.573a2.221,2.221,0,0,1-.747-.138,1.25,1.25,0,0,1-.463-.3,1.24,1.24,0,0,1-.3-.462,2.221,2.221,0,0,1-.138-.747C0,4.5,0,4.373,0,3.3S0,2.1.023,1.673A2.233,2.233,0,0,1,.162.926a1.255,1.255,0,0,1,.3-.463,1.242,1.242,0,0,1,.463-.3A2.221,2.221,0,0,1,1.672.023C2.1,0,2.224,0,3.3,0S4.5,0,4.924.023a2.233,2.233,0,0,1,.747.138,1.245,1.245,0,0,1,.463.3,1.246,1.246,0,0,1,.3.463,2.221,2.221,0,0,1,.138.747c.019.424.023.551.023,1.626s0,1.2-.023,1.626a2.231,2.231,0,0,1-.138.747,1.332,1.332,0,0,1-.764.763,2.221,2.221,0,0,1-.747.138C4.5,6.592,4.372,6.6,3.3,6.6s-1.2,0-1.625-.023",
    transform: "translate(0 0)",
    fill: "url(#radial-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34581",
    "data-name": "Path 34581",
    d: "M437.484,441.971a.817.817,0,1,1,.817.817.817.817,0,0,1-.817-.817m-.442,0a1.258,1.258,0,1,0,1.258-1.258,1.258,1.258,0,0,0-1.258,1.258m2.272-1.308a.294.294,0,1,0,.294-.294h0a.294.294,0,0,0-.294.294m-2,3.3a1.355,1.355,0,0,1-.455-.084.811.811,0,0,1-.465-.465,1.352,1.352,0,0,1-.084-.455c-.012-.258-.014-.336-.014-.99s0-.732.014-.99a1.363,1.363,0,0,1,.084-.455.811.811,0,0,1,.465-.465,1.352,1.352,0,0,1,.455-.084c.258-.012.336-.014.99-.014s.732,0,.99.014a1.362,1.362,0,0,1,.455.084.811.811,0,0,1,.465.465,1.354,1.354,0,0,1,.084.455c.012.259.014.336.014.99s0,.732-.014.99a1.36,1.36,0,0,1-.084.455.812.812,0,0,1-.465.465,1.353,1.353,0,0,1-.455.084c-.258.012-.336.014-.99.014s-.732,0-.99-.014m-.02-4.431a1.8,1.8,0,0,0-.595.114,1.252,1.252,0,0,0-.717.717,1.8,1.8,0,0,0-.114.595c-.012.261-.015.345-.015,1.01s0,.749.015,1.01a1.8,1.8,0,0,0,.114.595,1.253,1.253,0,0,0,.717.717,1.8,1.8,0,0,0,.595.114c.261.012.345.015,1.01.015s.749,0,1.01-.015a1.8,1.8,0,0,0,.595-.114,1.253,1.253,0,0,0,.717-.717,1.792,1.792,0,0,0,.114-.595c.012-.261.015-.345.015-1.01s0-.749-.015-1.01a1.8,1.8,0,0,0-.114-.595,1.253,1.253,0,0,0-.717-.717,1.793,1.793,0,0,0-.595-.114c-.261-.012-.345-.015-1.01-.015s-.749,0-1.011.015",
    transform: "translate(-434.996 -438.658)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_65900",
    "data-name": "Group 65900",
    transform: "translate(1100.141 715.763)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -113.14, -8.76)",
    filter: "url(#Ellipse_529)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_529-2",
    "data-name": "Ellipse 529",
    cx: 12.5,
    cy: 12,
    rx: 12.5,
    ry: 12,
    transform: "translate(113 9)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(5.246 7.633)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Color-"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Youtube",
    d: "M205.6,374.838v-3.991l3.811,2Zm8.367-4.683a3.086,3.086,0,0,0-.561-1.41,2.008,2.008,0,0,0-1.413-.6c-1.974-.144-4.934-.144-4.934-.144h-.006s-2.961,0-4.934.144a2.008,2.008,0,0,0-1.413.6,3.085,3.085,0,0,0-.56,1.41,21.643,21.643,0,0,0-.141,2.3v1.078a21.627,21.627,0,0,0,.141,2.3,3.085,3.085,0,0,0,.56,1.41,2.381,2.381,0,0,0,1.555.607c1.128.109,4.8.143,4.8.143s2.964,0,4.937-.148a2.01,2.01,0,0,0,1.413-.6,3.086,3.086,0,0,0,.561-1.41,21.627,21.627,0,0,0,.141-2.3v-1.078a21.643,21.643,0,0,0-.141-2.3Z",
    transform: "translate(-200 -368)",
    fill: "#ce1312",
    fillRule: "evenodd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_65899",
    "data-name": "Group 65899",
    transform: "translate(1154.104 755.524)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -167.1, -48.52)",
    filter: "url(#Ellipse_528)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_528-2",
    "data-name": "Ellipse 528",
    cx: 10,
    cy: 9.5,
    rx: 10,
    ry: 9.5,
    transform: "translate(167 49)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "tiktok-svgrepo-com_1_",
    "data-name": "tiktok-svgrepo-com (1)",
    transform: "translate(3.438 3.537)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34582",
    "data-name": "Path 34582",
    d: "M8.065,12.131a1.875,1.875,0,0,1,.866-1.418,2.055,2.055,0,0,1,1.652-.224V8.756a3.941,3.941,0,0,1,.667.039v2.23a2.054,2.054,0,0,0-1.652.225,1.875,1.875,0,0,0-.866,1.418,1.993,1.993,0,0,0,.377,1.24q-.116-.059-.236-.135A1.867,1.867,0,0,1,8.065,12.131ZM15.04,5.552a3,3,0,0,1-.766-1.506h.636a2.765,2.765,0,0,0,.8,2.043l.013.014A3.662,3.662,0,0,1,15.04,5.552ZM18.1,7.122V9.307a8.225,8.225,0,0,1-1.412-.184,5.517,5.517,0,0,1-1.377-.541s-.372-.234-.4-.25v4.513a4.373,4.373,0,0,1-.279,1.4,4.227,4.227,0,0,1-.774,1.226,4.309,4.309,0,0,1-3.17,1.386,4.465,4.465,0,0,1-2.357-.676,4.685,4.685,0,0,1-.673-.541l.006,0a4.465,4.465,0,0,0,2.357.676,4.309,4.309,0,0,0,3.17-1.386,4.22,4.22,0,0,0,.774-1.226,4.388,4.388,0,0,0,.279-1.4V7.8c.03.017.4.25.4.25a5.509,5.509,0,0,0,1.377.541,8.231,8.231,0,0,0,1.412.185V7.059A2.248,2.248,0,0,0,18.1,7.122Z",
    transform: "translate(-5.78 -3.509)",
    fill: "#ee1d52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34583",
    "data-name": "Path 34583",
    d: "M16.287,7.059V8.771a8.234,8.234,0,0,1-1.412-.184A5.523,5.523,0,0,1,13.5,8.045s-.372-.234-.4-.25v4.513a4.372,4.372,0,0,1-.279,1.4,4.226,4.226,0,0,1-.774,1.226,4.309,4.309,0,0,1-3.17,1.386,4.465,4.465,0,0,1-2.357-.676l-.006,0a3.959,3.959,0,0,1-.962-1.456.006.006,0,0,1,0,0A4.25,4.25,0,0,1,5.3,12.725a3.89,3.89,0,0,1,.51-1.848A4.392,4.392,0,0,1,6.8,9.718,4.175,4.175,0,0,1,7.975,9.05a4.092,4.092,0,0,1,1.46-.294v1.733a2.06,2.06,0,0,0-1.652.224,1.812,1.812,0,0,0-.058,3.06q.12.076.236.135a1.8,1.8,0,0,0,.432.4,1.954,1.954,0,0,0,1.95.178,1.789,1.789,0,0,0,1.007-1.06,2.471,2.471,0,0,0,.1-.876V4.046h1.672a3,3,0,0,0,.766,1.506,3.664,3.664,0,0,0,.68.551,3.549,3.549,0,0,0,.932.683A3.742,3.742,0,0,0,16.287,7.059Z",
    transform: "translate(-4.631 -3.509)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34584",
    "data-name": "Path 34584",
    d: "M4.489,22.757h0l.041.112C4.526,22.857,4.511,22.818,4.489,22.757Z",
    transform: "translate(-4.238 -12.613)",
    fill: "#69c9d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34585",
    "data-name": "Path 34585",
    d: "M7.344,13.007a4.177,4.177,0,0,0-1.176.668,4.392,4.392,0,0,0-.99,1.162,3.888,3.888,0,0,0-.51,1.848,4.25,4.25,0,0,0,.249,1.459.006.006,0,0,0,0,0,4.356,4.356,0,0,0,.63,1.095,4.267,4.267,0,0,0,.332.361,4.57,4.57,0,0,1-1-.9,4.3,4.3,0,0,1-.628-1.089.025.025,0,0,1,0,0v0A4.229,4.229,0,0,1,4,16.148a3.89,3.89,0,0,1,.51-1.848,4.386,4.386,0,0,1,.99-1.162,4.168,4.168,0,0,1,1.176-.668,4.163,4.163,0,0,1,.83-.234,4.3,4.3,0,0,1,1.3-.018v.494A4.093,4.093,0,0,0,7.344,13.007Z",
    transform: "translate(-4 -7.466)",
    fill: "#69c9d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34586",
    "data-name": "Path 34586",
    d: "M15.649,3.537H13.978v8.508a2.506,2.506,0,0,1-.1.876,1.8,1.8,0,0,1-1.007,1.059,1.951,1.951,0,0,1-1.95-.178,1.8,1.8,0,0,1-.433-.4,1.927,1.927,0,0,0,1.715.043,1.794,1.794,0,0,0,1.006-1.06,2.465,2.465,0,0,0,.1-.875V3h2.308A2,2,0,0,0,15.649,3.537ZM18.81,6.076v.473a3.743,3.743,0,0,1-.783-.273,3.548,3.548,0,0,1-.932-.683,2.642,2.642,0,0,0,.265.146A3.106,3.106,0,0,0,18.81,6.076Z",
    transform: "translate(-7.155 -3)",
    fill: "#69c9d0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_65976",
    "data-name": "Group 65976",
    transform: "translate(9 -103)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 978, 810)",
    filter: "url(#Rectangle_6091)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6091-2",
    "data-name": "Rectangle 6091",
    width: 123,
    height: 86,
    rx: 5,
    transform: "translate(126 118)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_65975",
    "data-name": "Group 65975",
    transform: "translate(107 119)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Frequency:",
    transform: "translate(1004 822)",
    fill: "#262626",
    fontSize: 5,
    fontFamily: "Objectivity-Medium, Objectivity",
    fontWeight: 500,
    letterSpacing: "-0.05em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Frequency:")), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5564",
    "data-name": "Rectangle 5564",
    width: 44,
    height: 14,
    rx: 7,
    transform: "translate(1004 840)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_5922",
    "data-name": "Rectangle 5922",
    transform: "translate(1053 840)",
    fill: "#fff7f2",
    stroke: "#ff6500",
    strokeWidth: 0.4
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 14,
    rx: 7,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.2,
    y: 0.2,
    width: 43.6,
    height: 13.6,
    rx: 6.8,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Daily",
    transform: "translate(1020 849)",
    fill: "#707070",
    fontSize: 5,
    fontFamily: "Geist, Helvetica Neue"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Daily")), /*#__PURE__*/React.createElement("text", {
    id: "Weekly",
    transform: "translate(1067 849)",
    fontSize: 5,
    fontFamily: "Geist, Helvetica Neue"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Weekly")), /*#__PURE__*/React.createElement("text", {
    id: "Repeat",
    transform: "translate(1004 835)",
    fontSize: 5,
    fontFamily: "Objectivity-Medium, Objectivity",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Repeat")), /*#__PURE__*/React.createElement("text", {
    id: "On_the_first",
    "data-name": "On the first",
    transform: "translate(1004 865)",
    fontSize: 5,
    fontFamily: "Objectivity-Medium, Objectivity",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "On the first")), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_391",
    "data-name": "Ellipse 391",
    cx: 6.5,
    cy: 6.5,
    r: 6.5,
    transform: "translate(1004 872)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_392",
    "data-name": "Ellipse 392",
    cx: 7,
    cy: 6.5,
    rx: 7,
    ry: 6.5,
    transform: "translate(1020 872)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_393",
    "data-name": "Ellipse 393",
    transform: "translate(1036 872)",
    fill: "#fff7f2",
    stroke: "#ff6500",
    strokeWidth: 0.4
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 6.5,
    r: 6.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 6.5,
    r: 6.3,
    fill: "none"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_394",
    "data-name": "Ellipse 394",
    cx: 6.5,
    cy: 6.5,
    r: 6.5,
    transform: "translate(1052 872)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_395",
    "data-name": "Ellipse 395",
    transform: "translate(1068 872)",
    fill: "#fff7f2",
    stroke: "#ff6500",
    strokeWidth: 0.4
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 6.5,
    r: 6.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 6.5,
    r: 6.3,
    fill: "none"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_396",
    "data-name": "Ellipse 396",
    cx: 6.5,
    cy: 6.5,
    r: 6.5,
    transform: "translate(1084 872)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_397",
    "data-name": "Ellipse 397",
    cx: 6.5,
    cy: 6.5,
    r: 6.5,
    transform: "translate(1100 872)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("text", {
    id: "S",
    transform: "translate(1011 880)",
    fill: "#707070",
    fontSize: 4,
    fontFamily: "Geist, Helvetica Neue"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -1.296,
    y: 0
  }, "S")), /*#__PURE__*/React.createElement("text", {
    id: "M",
    transform: "translate(1027 880.6)",
    fill: "#707070",
    fontSize: 5,
    fontFamily: "Geist, Helvetica Neue"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -2.178,
    y: 0
  }, "M")), /*#__PURE__*/React.createElement("text", {
    id: "T",
    transform: "translate(1042.6 880.2)",
    fontSize: 5,
    fontFamily: "Geist, Helvetica Neue"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -1.435,
    y: 0
  }, "T")), /*#__PURE__*/React.createElement("text", {
    id: "W",
    transform: "translate(1058 880)",
    fill: "#707070",
    fontSize: 5,
    fontFamily: "Geist, Helvetica Neue"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -2.315,
    y: 0
  }, "W")), /*#__PURE__*/React.createElement("text", {
    id: "T-2",
    "data-name": "T",
    transform: "translate(1075 880.2)",
    fontSize: 5,
    fontFamily: "Geist, Helvetica Neue"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -1.435,
    y: 0
  }, "T")), /*#__PURE__*/React.createElement("text", {
    id: "F",
    transform: "translate(1090.5 880.6)",
    fill: "#707070",
    fontSize: 5,
    fontFamily: "Geist, Helvetica Neue"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -1.435,
    y: 0
  }, "F")), /*#__PURE__*/React.createElement("text", {
    id: "S-2",
    "data-name": "S",
    transform: "translate(1106.2 879.6)",
    fill: "#707070",
    fontSize: 4,
    fontFamily: "Geist, Helvetica Neue"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -1.296,
    y: 0
  }, "S")))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAIcreate);
export default __webpack_public_path__ + "static/media/AIcreate.349a5fbabe3ec987f12a4d8e1ee2bc7e.svg";
export { ForwardRef as ReactComponent };